module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAANCAYAAACQN/8FAAAA0ElEQVQokXXPIUsEQRQH8N/NWZSzmERQ46VTrmgQDAa/gFgMhvkQt9U6WavbBBFMckWxGMwKVrPYxKBJ1rILe+P6T2/e+80Mr1dVlXaK0jLOEFP02fTnMhRwixFWsd3Mgtk81Ai2itL9H1iUbrCTXdwrStfQm5xXA0yx6//cBRzV373gpwO9YRhwlaIlbOCrA45TtB5S9FE3FrGQoccUvc8sgyH6GTxtijYcZ+g1RZddcD+DB+1DgKK0mQ2OU/Tchv3vtZN5XGAFTzhM0TR73S/Tfiz37AJnDQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/newmould/up.png
// module id = 7ycN
// module chunks = 3